import { render, staticRenderFns } from "./SendCompactIcon.vue?vue&type=template&id=fe63d51c&scoped=true"
import script from "./SendCompactIcon.vue?vue&type=script&lang=js"
export * from "./SendCompactIcon.vue?vue&type=script&lang=js"
import style0 from "./SendCompactIcon.vue?vue&type=style&index=0&id=fe63d51c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe63d51c",
  null
  
)

export default component.exports